<app-sub-page class="width-100" navBackRoute="/about">
  <div class="feedback-content">
    <div class="body">
      <div class="text">Please select a category for your feedback and provide as much detail as possible.</div>
      <div class="input-group">
        <p-dropdown
          [options]="feedbackOptions"
          [(ngModel)]="selectedFeedback"
          optionLabel="label"
          appendTo="body"
          placeholder="Feedback Type"
        />
        <textarea
          placeholder="Enter feedback here..."
          rows="1"
          pInputTextarea
          [autoResize]="false"
          [(ngModel)]="userFeedback"
          [disabled]="!this.selectedFeedback"
        ></textarea>
      </div>
    </div>
    <div class="text">
      Click <span style="font-weight: 600; color: var(--text-color)">Create</span> to open your email application and
      attach any relevant screenshots or videos before sending.
    </div>
    <div class="flex width-100">
      <app-button
        class="width-100"
        label="Create"
        [disabled]="!this.userFeedback"
        [outlined]="globalService.theme() === 'dark'"
        (click)="onSubmit()"
      />
    </div>
  </div>
</app-sub-page>
